import React from "react";
import { Avatar } from "antd";

const LeadInfoCard = ({ initials, title, subtitle, isSelected, onClick, className = "" }) => {
  return (
    <div
      className={`flex items-center gap-3 p-3 rounded-lg border border-solid transition-all ${
        isSelected ? "border-twLinkColor bg-[#E6F4FF]" : "border-[#D9D9D9]"
      } ${onClick && !isSelected ? "cursor-pointer hover:bg-gray-50" : ""} ${
        onClick && isSelected ? "cursor-pointer" : ""
      } ${className}`}
      onClick={onClick}
    >
      <Avatar size={40} style={{ backgroundColor: "#d9d9d9" }}>
        {initials}
      </Avatar>
      <div>
        <p className="text-black-88 text-sm font-semibold mb-0">{title}</p>
        {subtitle && <p className="text-black-45 text-sm mb-0">{subtitle}</p>}
      </div>
    </div>
  );
};

export default LeadInfoCard;
